import { webAPI } from '../../../axiosInstance';


const getOneProduct = async (productId: any) => {
  const response = await webAPI.get(`/products/${productId}`);
  return response.data;
};


const editProduct = async (data: any) => {
  console.log('data', data)
  const response = await webAPI.put(`/products/edit/${data?.productId}`, data?.formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export { getOneProduct, editProduct };
